/* eslint-disable react/react-in-jsx-scope */
import { message } from 'antd';
import { uploadSubmit } from '@/services/contacts/department';
import { setSpinProps } from '@/utils';

const initState = () => {
  return {
    /**
     * 表头 Array<Object>
     * type: 表头单元格类型 0:未匹配 1:部门名称 2:部门类型 Number
     * value: 表头单元格值 String
     */
    columns: [],
    /**
     * table数据 Array<Object>
     * type: 表头单元格类型 0:未匹配 1:部门名称 2:部门类型 Number
     * value: 表头单元格值 String
     */
    data: [],
    // 初始数据
    rows: [],
    // 初始表头数据
    headers: [],
    visible: false, // modal显示状态
    selectedColumnInfo: {}, // 要修改的列信息
    // modal内选项列表
    deptType: [
      {
        type: 1,
        name: '部门名称',
      },
      {
        type: 2,
        name: '部门类型',
      },
    ],
    // 加载状态
    spinProps: {
      spinning: false,
      tip: '加载中...',
    },
  };
};

export default {
  namespace: 'deptUpload',

  state: initState(),

  effects: {
    *fetchSubmit({ params, callback }, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '提交中...' });

        const { columns, rows, deptId } = params;
        const headers = columns.map(({ value, type }) => ({ value, type }));

        // duplicatedDeptName：重复的部门名称
        // unknownDeptType：未知的部门类型
        const { duplicatedDeptName = [], unknownDeptType = [], success } = yield call(
          uploadSubmit,
          {
            rows,
            deptId,
            headers,
          }
        );

        // success:判断请求是否成功，0：失败，1：成功
        if (success !== 1) {
          let msg = '导入失败：';
          if (duplicatedDeptName && duplicatedDeptName.length !== 0) {
            msg = `以下部门名称重复：${duplicatedDeptName.join('、')};`;
          }
          if (unknownDeptType && unknownDeptType.length !== 0) {
            msg = `您输入的部门类型${unknownDeptType.join('、')}，无法与系统中类型相对应，导入失败`;
          }
          yield message.error(msg);
          yield setSpinProps({ put });
        } else {
          message.success('导入成功');

          if (callback) {
            callback();
          }
        }
      } catch (error) {
        yield setSpinProps({ put });
      }
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    change(state, { payload }) {
      const { selectedInfo, selected } = payload;
      const { type: seletedType } = selected;
      const { columns } = state;
      const newColumns = columns;

      const selectTypeColumn = newColumns.find(({ type }) => type === seletedType);
      const seletedColumn = newColumns.find(({ key }) => key === selectedInfo.key);

      if (selectTypeColumn && seletedType !== 0) {
        selectTypeColumn.type = seletedType === 1 ? 2 : 1;
      }
      seletedColumn.type = seletedType;

      return {
        ...state,
        columns: newColumns,
        visible: false,
        selectedColumnInfo: {},
      };
    },
    reset() {
      return { ...initState() };
    },
  },
};
